<script setup lang="ts">
import type { ModalConfig } from '../modals/modal-types';
import { computed, ref, onMounted } from 'vue';

const props = defineProps<{ config: ModalConfig }>();

const dialog = ref<HTMLDialogElement | null>(null);

const widthClass = computed(() => (props.config.options.fitWidth ? 'w-fit max-w-[90vw]' : 'w-full max-w-lg'));

onMounted(() => {
  if (dialog.value) {
    dialog.value.showModal();
  }
});
</script>

<template>
  <dialog
    ref="dialog"
    :class="[
      'animate-in fade-in-0 pointer-events-auto mx-auto min-w-96 rounded-lg border border-slate-200 bg-white p-6 shadow-lg duration-200',
      widthClass,
    ]"
    @close="props.config.onClose(null)"
  >
    <component
      :is="config.component"
      v-bind="config.props as Record<string, unknown>"
      @modalClose="config.onClose($event)"
    />
  </dialog>
</template>
